export const stringToGradient = (name: string, angle: number = 135): string => {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  const hue1 = Math.abs(hash % 360);
  const hue2 = (hue1 + 40 + Math.abs((hash >> 8) % 60)) % 360;
  return `linear-gradient(${angle}deg, hsl(${hue1}, 70%, 55%), hsl(${hue2}, 70%, 45%))`;
};
